module.exports = __webpack_public_path__ + "05_long_black.570aa71a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/05_long_black.png
// module id = INFp
// module chunks = 0